'use client';

import { useEffect } from 'react';

export default function AnimationHydrationGate() {
    useEffect(() => {
        const root = document.documentElement;
        let secondFrame = 0;
        const firstFrame = window.requestAnimationFrame(() => {
            secondFrame = window.requestAnimationFrame(() => {
                root.dataset.motionHydrated = 'true';
            });
        });

        return () => {
            window.cancelAnimationFrame(firstFrame);
            if (secondFrame) window.cancelAnimationFrame(secondFrame);
        };
    }, []);

    return null;
}
